export enum RoutesSunpoint {
  SUNPOINT__AGB = '/sunpoint/agb',
  SUNPOINT__BODYFORMING = '/sunpoint/bodyforming',
  SUNPOINT__BRAEUNE = '/sunpoint/braeune',
  SUNPOINT__BRAEUNE__BRAEUNUNGSTIPPS = '/sunpoint/braeune/braeunungs-tipps',
  SUNPOINT__BRAEUNE__COLLAGEN = '/sunpoint/braeune/collagen',
  SUNPOINT__BRAEUNE__HAUTTYPENTEST = '/sunpoint/braeune/hauttypen-test',
  SUNPOINT__BRAEUNE__SOLARIUM = '/sunpoint/braeune/solarium',
  SUNPOINT__BRAEUNE__SONNENLICHTUNDVITAMIND = '/sunpoint/braeune/sonnenlicht-und-vitamin-d',
  SUNPOINT__BRAEUNE__SPRAYTANNINGBRAEUNUNGSDUSCHE = '/sunpoint/braeune/spray-tanning-braeunungsdusche',
  SUNPOINT__CLUB = '/sunpoint/club',
  SUNPOINT__CLUB__CLUBFAQ = '/sunpoint/club/club-faq',
  SUNPOINT__CLUB__KOMBICLUB = '/sunpoint/club/kombi-club',
  SUNPOINT__CLUB__SUNPOINTCLUB = '/sunpoint/club/sunpoint-club',
  SUNPOINT__CLUB__TANTASTICCLUB = '/sunpoint/club/tantastic-club',
  SUNPOINT__CLUB__WELLMAXXCLUB = '/sunpoint/club/wellmaxx-club',
  SUNPOINT__CLUB__YOUNGSTERTARIF = '/sunpoint/club/youngster-tarif',
  SUNPOINT__CLUBMITGLIEDWERDEN = '/sunpoint/clubmitglied-werden',
  SUNPOINT__CLUBVERTRAGKUENDIGEN = '/sunpoint/clubvertrag-kuendigen',
  SUNPOINT__CLUBVERTRAGWIDERRUFEN = '/sunpoint/clubvertrag-widerrufen',
  SUNPOINT__COOKIEEINSTELLUNGEN = '/sunpoint/cookie-einstellungen',
  SUNPOINT__COUPONS = '/sunpoint/coupons',
  SUNPOINT__DATENSCHUTZ = '/sunpoint/datenschutz',
  SUNPOINT__DEV = '/sunpoint/dev',
  SUNPOINT__FORMULARE = '/sunpoint/formulare',
  SUNPOINT__FRANCHISE = '/sunpoint/franchise',
  SUNPOINT__HOME = '/sunpoint/home',
  SUNPOINT__IMPRESSUM = '/sunpoint/impressum',
  SUNPOINT__JOBS = '/sunpoint/jobs',
  SUNPOINT__JOBS__BEWERBUNGREINIGUNGSKRAFT = '/sunpoint/jobs/bewerbung-reinigungskraft',
  SUNPOINT__JOBS__BEWERBUNGSTUDIOLEITERIN = '/sunpoint/jobs/bewerbung-studioleiterin',
  SUNPOINT__JOBS__BEWERBUNGSTUDIOMITARBEITERIN = '/sunpoint/jobs/bewerbung-studiomitarbeiterin',
  SUNPOINT__KONTAKT = '/sunpoint/kontakt',
  SUNPOINT__KOOPERATIONENINFLUENCER = '/sunpoint/kooperationen-influencer',
  SUNPOINT__KOSMETIK = '/sunpoint/kosmetik',
  SUNPOINT__KOSMETIK__BEAUTYTIPPS = '/sunpoint/kosmetik/beauty-tipps',
  SUNPOINT__KOSMETIK__MONATSANGEBOTE = '/sunpoint/kosmetik/monatsangebote',
  SUNPOINT__KOSMETIK__SOLARKOSMETIK = '/sunpoint/kosmetik/solarkosmetik',
  SUNPOINT__KOSMETIK__WIRKKOSMETIK = '/sunpoint/kosmetik/wirkkosmetik',
  SUNPOINT__NEWSLETTER = '/sunpoint/newsletter',
  SUNPOINT__PRESSE = '/sunpoint/presse',
  SUNPOINT__RELEASEDCOMPONENTS = '/sunpoint/released-components',
  SUNPOINT__SUNPOINTSETTINGSCAMPAIGNPOPUP = '/sunpoint/sunpoint-settings-campaign-popup',
  SUNPOINT__UEBERSUNPOINT = '/sunpoint/ueber-sunpoint',
  SUNPOINT__UEBERSUNPOINT__EXPANSIONSTANDORTFUERSUNPOINTANBIETEN = '/sunpoint/ueber-sunpoint/expansion-standort-fuer-sunpoint-anbieten',
  SUNPOINT__UEBERSUNPOINT__FRANCHISEPARTNERWERDEN = '/sunpoint/ueber-sunpoint/franchise-partner-werden',
  SUNPOINT__UEBERSUNPOINT__STUDIOFINDER = '/sunpoint/ueber-sunpoint/studiofinder',
  SUNPOINT__UEBERSUNPOINT__SUNPOINTAPPDIGITALEKUNDENKARTE = '/sunpoint/ueber-sunpoint/sunpoint-app-digitale-kundenkarte',
  SUNPOINT__UEBERSUNPOINT__SUNPOINTBEAUTYTANNINGSTUDIOS = '/sunpoint/ueber-sunpoint/sunpoint-beauty-tanning-studios',
  SUNPOINT__WELLMAXXWAVE = '/sunpoint/wellmaxx-wave',
  SUNPOINT__WIDERRUFSBELEHRUNG = '/sunpoint/widerrufsbelehrung',
}
